"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findContext = void 0;

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * Walks the dom tree up and collects the context of the element provided
 *
 * @param {*} element
 * @param {*} [categories=[]]
 * @return {*} 
 */
var findContext = function findContext(element) {
  var categories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  try {
    var cat = element.getAttribute("data-trk-ctx");

    if (cat) {
      categories.push(cat);
    }
  } catch (e) {
    console.warn(e);
  }

  if (element.parentElement) {
    findContext(element.parentElement, categories);
  }

  return categories;
};

exports.findContext = findContext;